import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { preRegistrationForm } from "./forms/PreRegistrationForm";
import { registrationForm } from "./forms/RegistrationForm";
import { abcdForm } from "./forms/ABCDForm";
import { hbcdForm } from "./forms/HBCDForm";
import { FormSchema } from "../../components/dynamicform/DynamicFormTypes";

type DomainOption = { label: string; value: string };
type PublicationDomains = { abcd: DomainOption[]; hbcd: DomainOption[] };

const initialState = {
    forms: [preRegistrationForm, registrationForm, abcdForm, hbcdForm],
    domains: { abcd: [], hbcd: [] } as PublicationDomains
};



const withDomainOptions = (form: FormSchema, fieldName: string, options: DomainOption[]): FormSchema => ({
    ...form,
    fields: form.fields.map((field: any) => field.name === fieldName ? { ...field, options } : field)
});

export const publicationSlice = createSlice({
    name: 'publication',
    initialState: initialState as any,
    // The `reducers` field lets us define reducers and generate associated actions
    reducers: {
        setFormStudy: (state, action: PayloadAction<any>) => {
            const abcdWithOptions = withDomainOptions(abcdForm, 'abcdDomains', state.domains.abcd)
            const hbcdWithOptions = withDomainOptions(hbcdForm, 'hbcdDomains', state.domains.hbcd)

            if(action.payload.length === 2){
                state.forms = [preRegistrationForm, registrationForm, abcdWithOptions, hbcdWithOptions]
            }
            else{
                if(action.payload[0] === 'abcd')
                {
                    const hbcdForm = makeNewFormStudy("HBCD", state.domains.hbcd)
                    state.forms = [preRegistrationForm, registrationForm, abcdWithOptions, hbcdForm]
                }
                else{
                    const abcdForm = makeNewFormStudy("ABCD", state.domains.abcd)
                    state.forms = [preRegistrationForm, registrationForm, abcdForm, hbcdWithOptions]
                }
            }
        },
        setDomainOptions: (state, action: PayloadAction<PublicationDomains>) => {
            state.domains = action.payload;
            state.forms.forEach((form: FormSchema) => {
                form.fields.forEach((field: any) => {
                    if (field.name === 'abcdDomains') field.options = action.payload.abcd;
                    if (field.name === 'hbcdDomains') field.options = action.payload.hbcd;
                });
            });
        }
    }
});

const makeNewFormStudy = ((study: string, domainOptions: DomainOption[]) => {
    const Form: FormSchema = {
        title: study + " Information",
        fields: [
            {
                name: study + "Domains",
                type: "checkbox",
                label: study + "Domains",
                numColumns: 2,
                options: domainOptions.map(option => ({ ...option, disabled: true }))
            },
            {
                name: study + "ReleaseVersion",
                type: "radio",
                label: "Please select which release version you used for your publication?",
                options: [
                    { label: "4.0 (DOI Link)", value: "4.0 (DOI Link)", disabled: true },
                    { label: "5.0 (DOI Link)", value: "5.0 (DOI Link)", disabled: true },
                    { label: "5.1 (DOI Link)", value: "5.1 (DOI Link)", disabled: true },
                    { label: "6.0 (DOI Link)", value: "6.0 (DOI Link)", disabled: true },


                ]
            }
        ]
    };
    return Form;
})

export const { setFormStudy, setDomainOptions } = publicationSlice.actions;

export default publicationSlice.reducer;

export const selectForms = (state: any) => state.publication.forms;

